import {useDataGrid} from "./data-grid/DataGridContext";
import DataGrid from "./data-grid/DataGrid";
import ApiService from "../Service/ApiService";
import {useEffect} from "react";

export default function CheckHistory() {
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();

    const initGridData = async () => {
        const response = await ApiService.UserProject.CheckHistory(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'operationKey',
            enableRowSelection: false,
            columns: [
                {title: 'Date', dataIndex: 'createdDate', key: 'createdDate', sorter: false, render: (text, record) => `${new Date(text).toLocaleString()}`},
                {title: 'Project Title', dataIndex: 'baseProjectTitle', key: 'baseProjectTitle', sorter: false},
                {title: 'Plan Title', dataIndex: 'basePlanTitle', key: 'basePlanTitle', sorter: false},
                {title: 'Flow Title', dataIndex: 'baseFlowTitle', key: 'baseFlowTitle', sorter: false},
                {title: 'Geometry Title', dataIndex: 'baseGeoTitle', key: 'baseGeoTitle', sorter: false},
                {title: 'Message Count', dataIndex: 'messageCount', key: 'messageCount', sorter: false},
            ]
        })
    }, [])

    return (
        <>
            <DataGrid />
        </>
    )
}